/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
require("dotenv").config();

// import firebase
import { firebase } from "@/utilities/firebase";
import Vue from "vue";
import App from "./App.vue";

// Vuesax Component Framework
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax
Vue.use(Vuesax);

//loading
import "vue-loading-overlay/dist/vue-loading.css";

//popover
import Popover from "vue-js-popover";
Vue.use(Popover);

import "@/assets/css/multiselect.css";
import Multiselect from "vue-multiselect";
Vue.component("multiselect", Multiselect);

import VeeValidate from "vee-validate";
Vue.use(VeeValidate);

//v-tooltip
import VTooltip from "v-tooltip";
Vue.use(VTooltip);

// DOM purify
import VueDOMPurifyHTML from "vue-dompurify-html";
Vue.use(VueDOMPurifyHTML);

// Theme Configurations
import "../themeConfig.js";

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";

//popover
import "./assets/css/popover.css";

// Tailwind
import "@/assets/css/main.css";

//update preview styles
import "@/assets/css/preview.css";

// Vue Router
import router from "./router";

// Vuex Store
import store from "./store/store";

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from "vue2-hammer";
Vue.use(VueHammer);

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

// Feather font icon
require("./assets/css/iconfont.css");

import { AuthenticationManager } from "@/utilities/authenticationManager";

Vue.config.productionTip = false;

// apollo
import { apolloClientFactory, headersBuilder } from "@/utilities/ApolloClient";
import VueApollo from "vue-apollo";
Vue.use(VueApollo);

let app;
export let apolloClient = {};
let apolloHeaders = {};
let apolloProvider = {};

firebase.auth().onAuthStateChanged(user => {
  // TODO console.log("AuthStateChanged: ", user);

  if (user) {
    user
      .getIdToken()
      .then(() => {
        // TODO console.log("user present: ", user);

        let authenticationManager = new AuthenticationManager();
        // TODO console.log("Authentication Manager Created");

        authenticationManager
          .checkAuthentication(user)
          .then(authenticatedUser => {
            apolloHeaders = headersBuilder(
              authenticatedUser.idToken,
              authenticatedUser.team.id
            );
            // TODO console.log("apolloheaders: ", apolloHeaders);
            apolloClient = apolloClientFactory(apolloHeaders);
            apolloProvider = new VueApollo({
              defaultClient: apolloClient
            });

            //Creating new settings for newly created user.
            // if (authenticatedUser.newlyCreatedUser) {
            //   authenticatedUser
            //     .createNewUserSettings()
            //     .then(() => {})
            //     .catch();
            //   authenticatedUser.newlyCreatedUser = false;
            // }

            // TODO console.log(
            //   "response from authentication manager: ",
            //   authenticatedUser
            // );
            store.dispatch("updateUserInfo", authenticatedUser);
            if (!app) {
              app = new Vue({
                router,
                store,
                apolloProvider,
                render: h => h(App)
              }).$mount("#app");
            }
          })
          .catch(error => {
            console.error("error checking authentication: ", error);
          });
      })
      .catch(error => {
        console.error(error);
      });
  } else {
    apolloClient = apolloClientFactory({});
    apolloProvider = new VueApollo({
      defaultClient: apolloClient
    });
    if (!app) {
      app = new Vue({
        router,
        store,
        apolloProvider,
        render: h => h(App)
      }).$mount("#app");
    }
  }
});
